angular.module('impactx.websocket').service('WebSocketService', [
    '$websocket',
    'ToastService',
    '$securityManager',
    '$timeout',
    '$config',
    WebSocketService]);

function WebSocketService($websocket, ToastService, $securityManager, $timeout, $config) {
    var self = this;
    self.lastMessage = {};
    const statusModes = Object.freeze({
        none: 0,
        init: 1,
        transmitting: 2,
        connected: 4,
        error: 8
    });
    self.currentStatus = statusModes.none;

    var init = function (uri) {
        return $timeout(function () {
            self.currentStatus = statusModes.init;
            var baseUrl = $config.baseURL;
            baseUrl = baseUrl.replace("https", "wss").replace("http", "ws");
            if (baseUrl.charAt(baseUrl.length - 1) !== '/') {
                baseUrl += "/";
            }

            self.ws = $websocket(baseUrl + uri);
            console.log("Connecting to " + baseUrl + uri);

            self.ws.onMessage(function (event) {
                try {
                    self.lastMessage = JSON.parse(event.data);
                    $timeout(function () {
                        self.currentStatus = statusModes.connected;
                    }, 1000);
                } catch (e) {
                    console.log("Error while parsing the message for the index queue websocket");
                }
            });

            self.ws.onError(function () {
                console.log("Error while connecting to the websocket + \"" + uri + "\"");
                self.currentStatus = statusModes.error;
            });

            self.ws.onOpen(function () {
                console.log("Successfully connected to " + uri);
                self.currentStatus = statusModes.connected;
            });
        });
    };

    var send = function (payload) {
        self.currentStatus = statusModes.transmitting;
        var message = payload ? payload : {};
        message.token = $securityManager.getToken();
        return self.ws.send(JSON.stringify(message));
    };

    var close = function () {
        self.lastMessage = {};
        self.ws.close();
        self.currentStatus = statusModes.none;
    };

    var getLastMessage = function () {
        return self.lastMessage;
    };

    var getStatus = function () {
        return self.currentStatus;
    };

    return {
        init: init,
        send: send,
        getLastMessage: getLastMessage,
        close: close,
        getStatus: getStatus,
        statusModes: statusModes
    };
}